import ReportDetails from '../Common/report/ReportDetails';

const PetReportDetails = () => (
  <ReportDetails title="State Report" downloadEndpoint="pet/report" />
);

export default PetReportDetails;
